import axios from "axios";
import { instance, baseUrl } from "../../axios";
import { SETTINGS } from "../constants";

export const getSettingsAction = () => async (dispatch) => {
  try {
    const res = await axios.get(`${baseUrl}/setting`);
    dispatch({ type: SETTINGS.GET_SETTINGS_SUCCESS, payload: res.data });
  } catch (err) {
    // keep reducer defaults
  }
};

const saveSettingsAction = (settings) => async () => {
  try {
    await instance.post("/setting", settings);
  } catch (err) {
    // silent
  }
};

export const updateContactoAction = (contacto) => (dispatch, getState) => {
  dispatch({ type: SETTINGS.UPDATE_CONTACTO, payload: contacto });
  dispatch(saveSettingsAction(getState().settings));
};

export const updateEcografiasAction = (ecografias) => (dispatch, getState) => {
  dispatch({ type: SETTINGS.UPDATE_ECOGRAFIAS, payload: ecografias });
  dispatch(saveSettingsAction(getState().settings));
};

export const updateEstudiosAction = (estudios) => (dispatch, getState) => {
  dispatch({ type: SETTINGS.UPDATE_ESTUDIOS, payload: estudios });
  dispatch(saveSettingsAction(getState().settings));
};

export const updateConsultasAction = (consultas) => (dispatch, getState) => {
  dispatch({ type: SETTINGS.UPDATE_CONSULTAS, payload: consultas });
  dispatch(saveSettingsAction(getState().settings));
};

export const updateModeloEcoAction = (modeloEco) => (dispatch, getState) => {
  dispatch({ type: SETTINGS.UPDATE_MODELO_ECO, payload: modeloEco });
  dispatch(saveSettingsAction(getState().settings));
};

export const updateConveniosAction = (convenios) => (dispatch, getState) => {
  dispatch({ type: SETTINGS.UPDATE_CONVENIOS, payload: convenios });
  dispatch(saveSettingsAction(getState().settings));
};

export const updateEspecialidadesAction = (especialidades) => (dispatch, getState) => {
  dispatch({ type: SETTINGS.UPDATE_ESPECIALIDADES, payload: especialidades });
  dispatch(saveSettingsAction(getState().settings));
};

export const updateDisplayTimezoneAction = (displayTimezone) => (dispatch, getState) => {
  dispatch({ type: SETTINGS.UPDATE_DISPLAY_TIMEZONE, payload: displayTimezone });
  dispatch(saveSettingsAction(getState().settings));
};
